// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-HHh","productName":"Table_productName__1OJ-S"};